/**
 * @packageDocumentation
 * @module api.functional.admin.companies
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CreateCompanyDto } from "../../../structures/CreateCompanyDto";
import type { PaginationQuery } from "../../../structures/PaginationQuery";
import type { ServiceResponseCreatedCompanyDto } from "../../../structures/ServiceResponseCreatedCompanyDto";
import type { ServiceResponsenamestringidnumberserviceIdnumberprefixstringcreatedAtDateupdatedAtDateisLegalEntitybooleanenableAdvancedStockbooleaninvitationsInvitationResultDto } from "../../../structures/ServiceResponsenamestringidnumberserviceIdnumberprefixstringcreatedAtDateupdatedAtDateisLegalEntitybooleanenableAdvancedStockbooleaninvitationsInvitationResultDto";
import type { ServiceResponsenull } from "../../../structures/ServiceResponsenull";
import type { ServiceResponsePageOfGetCompanyDto } from "../../../structures/ServiceResponsePageOfGetCompanyDto";
import type { UpdateCompanyDto } from "../../../structures/UpdateCompanyDto";

export * as prefix_available from "./prefix_available/index";
export * as bulk from "./bulk/index";

/**
 * @controller CompanyController.getCompanies
 * @path GET /admin/companies
 * @accessor api.functional.admin.companies.getCompanies
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getCompanies(
  connection: IConnection,
  query: getCompanies.Query,
): Promise<getCompanies.Output> {
  return PlainFetcher.fetch(connection, {
    ...getCompanies.METADATA,
    template: getCompanies.METADATA.path,
    path: getCompanies.path(query),
  });
}
export namespace getCompanies {
  export type Query = PaginationQuery;
  export type Output = ServiceResponsePageOfGetCompanyDto;

  export const METADATA = {
    method: "GET",
    path: "/admin/companies",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/admin/companies";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}

/**
 * @controller CompanyController.createCompany
 * @path POST /admin/companies
 * @accessor api.functional.admin.companies.createCompany
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function createCompany(
  connection: IConnection,
  body: createCompany.Body,
): Promise<createCompany.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...createCompany.METADATA,
      template: createCompany.METADATA.path,
      path: createCompany.path(),
    },
    body,
  );
}
export namespace createCompany {
  export type Body = CreateCompanyDto;
  export type Output = ServiceResponseCreatedCompanyDto;

  export const METADATA = {
    method: "POST",
    path: "/admin/companies",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/admin/companies";
}

/**
 * @controller CompanyController.updateCompany
 * @path PATCH /admin/companies/:id
 * @accessor api.functional.admin.companies.updateCompany
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function updateCompany(
  connection: IConnection,
  id: string,
  body: updateCompany.Body,
): Promise<updateCompany.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...updateCompany.METADATA,
      template: updateCompany.METADATA.path,
      path: updateCompany.path(id),
    },
    body,
  );
}
export namespace updateCompany {
  export type Body = UpdateCompanyDto;
  export type Output =
    | ServiceResponsenamestringidnumberserviceIdnumberprefixstringcreatedAtDateupdatedAtDateisLegalEntitybooleanenableAdvancedStockbooleaninvitationsInvitationResultDto
    | ServiceResponsenull;

  export const METADATA = {
    method: "PATCH",
    path: "/admin/companies/:id",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/admin/companies/${encodeURIComponent(id?.toString() ?? "null")}`;
}

/**
 * @controller CompanyController.deleteCompany
 * @path DELETE /admin/companies/:id
 * @accessor api.functional.admin.companies.deleteCompany
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function deleteCompany(
  connection: IConnection,
  id: string,
): Promise<deleteCompany.Output> {
  return PlainFetcher.fetch(connection, {
    ...deleteCompany.METADATA,
    template: deleteCompany.METADATA.path,
    path: deleteCompany.path(id),
  });
}
export namespace deleteCompany {
  export type Output = ServiceResponsenull;

  export const METADATA = {
    method: "DELETE",
    path: "/admin/companies/:id",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/admin/companies/${encodeURIComponent(id?.toString() ?? "null")}`;
}
